import React from 'react';

type Params = {
  fullName: string;
  title: string;
};
const coworkerResultComponent = ({ fullName, title }: Params) => <span>{title ? `${fullName} (${title})` : fullName}</span>;

export default coworkerResultComponent;
